import { AttributeDeleterDialogViewModel } from '@Alternatives/Attributes/Components/AttributeDeleterDialog';
import AttributeDeleterDialog from '@Alternatives/Attributes/Components/AttributeDeleterDialog.vue';
import { AttributeDependenciesDialogViewModel } from '@Alternatives/Attributes/Components/AttributeDependenciesDialog';
import AttributeDependenciesDialog from '@Alternatives/Attributes/Components/AttributeDependenciesDialog.vue';
import { DeleteAttributeCommandV1 } from '@Alternatives/Attributes/Domain/commands-core';
import AttributesCommands from '@Alternatives/Attributes/Domain/commands-vue-component';
import AttributesQueries from '@Alternatives/Attributes/Domain/queries-vue-component';
import { AttributeDependenciesReadModel } from '@Alternatives/Attributes/Domain/readmodels';
import GoalNavigation from "@common/Components/GoalNavigation.vue";
import PortfolioOrDecisionNavigation from "@common/Components/PortfolioOrDecisionNavigation.vue";
import { dynamicUiRoutes } from '@common/dynamicUiRoutes';
import { ICommandStatus } from '@cqrs/cqrs';
import WeightedScoresCommands from '@Criteria/WeightedScores/Domain/commands-vue-component';
import WeightedScoresQueries from '@Criteria/WeightedScores/Domain/queries-vue-component';
import { WeightedScoreReadModel, WeightedScoresPageReadModel } from '@Criteria/WeightedScores/Domain/readmodels';
import { Component, mixins } from 'vue-facing-decorator';

@Component({
    components: {
        GoalNavigation, PortfolioOrDecisionNavigation, AttributeDeleterDialog, AttributeDependenciesDialog
    }
})
export default class WeightedScoresPage extends mixins(WeightedScoresQueries, WeightedScoresCommands, AttributesQueries, AttributesCommands)
{
    get workspaceId() { return Number.parseInt(this.$route.params.workspaceId); }
    get projectId() { return Number.parseInt(this.$route.params.projectId); }
    get evalModelId() { return Number.parseInt(this.$route.params.evalModelId); }

    get url_CreateWeightedScorePage(): string
    {
        return dynamicUiRoutes.Criteria_CreateWeightedScorePage1(this.$route, this.workspaceId, this.projectId, this.evalModelId);
    }

    url_EditWeightedScorePage(scoreId: string): string
    {
        return dynamicUiRoutes.Criteria_EditWeightedScorePage1(this.$route, this.workspaceId, this.projectId, this.evalModelId, scoreId);
    }



    initialized: boolean = false;
    rm: WeightedScoresPageReadModel | null = null;

    attrDependenciesDialog = new AttributeDependenciesDialogViewModel();
    attrDeleterDialog = new AttributeDeleterDialogViewModel();

    get alternativesListId(): number { return this.rm.AlternativesListId; }
    get goalName(): string { return this.rm.GoalName; }
    get scores(): WeightedScoreReadModel[] { return this.rm.Scores; }




    handleShowAttributeDeleter(attrId: number)
    {
        const score = this.scores.find(s => s.AttributeId === attrId);

        this.attrDeleterDialog.show(score.AttributeId, score.Name);
        this.runAttributeDependenciesQueryV1(this.workspaceId, this.projectId, this.alternativesListId, score.AttributeId);
    }

    handleShowAttributeDependencies(attrId: number)
    {
        const score = this.scores.find(s => s.AttributeId === attrId);

        this.attrDeleterDialog.close();

        this.attrDependenciesDialog.show(score.AttributeId, score.Name);
        this.runAttributeDependenciesQueryV1(this.workspaceId, this.projectId, this.alternativesListId, score.AttributeId);
    }

    handleDeleteAttributeCommand(attrId: number)
    {
        this.invokeDeleteAttributeCommandV1(this.workspaceId, this.projectId, this.rm.AlternativesListId, attrId)
    }


    mounted()
    {
        document.title = "Weighted scores | TransparentChoice";
        this.runWeightedScoresPageQueryV1(this.workspaceId, this.projectId, this.evalModelId);
    }

    onSetModel(model: any, modelName: string)
    {
        if (modelName === "WeightedScoresPageReadModel")
        {
            this.rm = model as WeightedScoresPageReadModel;

            this.initialized = true;
        }
        else if (modelName === "AttributeDependenciesReadModel")
        {
            const rm = model as AttributeDependenciesReadModel;

            this.attrDependenciesDialog.setData(rm);
            this.attrDeleterDialog.setData(rm);
        }
    }

    onCommandSucceed(cmd: any, correlationId: string, result: any)
    {
        if (DeleteAttributeCommandV1.matchType(cmd))
        {
            this.rm.Scores = this.rm.Scores.filter(a => a.AttributeId !== Number.parseInt(correlationId));
            this.attrDeleterDialog.close();
        }
    }

    onCommandFailed(status: ICommandStatus)
    {
        //if (CreateSurveyCommandV1.matchType(status.Command))
        //{
        //    this.surveyEditorDialog.displayValidationErrors(status.ValidationErrors);
        //}
    }
}
